export default function addQueryParamToHref(href: string, paramKey: string, paramValue: string) {
  // calculate part we need to add, paramKey=paramValue
  const queryParam = `${encodeURIComponent(paramKey)}=${encodeURIComponent(paramValue)}`;

  // split by #, to handle fragments: https://example.com/foo?bar=baz#qux
  const urlParts = href.split('#');

  // check for ?, add param accordingly
  const hasQueryString = urlParts[0].includes('?');
  if (hasQueryString) {
    urlParts[0] += `&${queryParam}`;
  } else {
    urlParts[0] += `?${queryParam}`;
  }

  // combine back together
  return urlParts.join('#');
}
